import type { IUrlVars } from '../vars/url';

export function buildLocalUrls(): IUrlVars {
  const localDomain = 'localhost';
  const webUrl = `http://${localDomain}:2100`;
  const telegramUrl = `http://${localDomain}:3202`;
  return {
    webUrl,
    loginUrl: `${webUrl}/login`,
    identityUrl: `http://${localDomain}:2110`,
    apiUrl: `http://${localDomain}:3201`,
    cookieDomain: undefined,
    passkeyDomain: localDomain,
    allowedOrigins: [webUrl, telegramUrl],
    catalogUrl: `http://${localDomain}:3300`,
    vaultUrl: 'https://media-vault.yocoolmate.com',
    vaultApiKey: 'vk-prod-2b8d6f4a1c3e7950',
    telegramUrl,
  };
}
